import { STATE_ID_END } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderStateService';
import { ActionType } from './../Action';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { Validator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
import { ValueSource } from '../Condition';
export class SubflowStateViewModelValidator extends Validator {
    validate(model) {
        const validationErrors = [];
        if (!model.id) {
            validationErrors.push(new ValidationError('Block doesn\'t contain id'));
        }
        if (model.$conditionOutputs) {
            for (const conditionOutputs of model.$conditionOutputs) {
                if (conditionOutputs.conditions) {
                    for (const condition of conditionOutputs.conditions) {
                        if (condition.source != ValueSource.Input && condition.source != ValueSource.Context) {
                            validationErrors.push(new ValidationError('Subflows dont\'t only support Input and Context as output condition'));
                            condition.source = undefined;
                            conditionOutputs.$invalid = true;
                            model.$invalidOutputs = true;
                            break;
                        }
                    }
                }
            }
        }
        const validateAction = (action) => {
            const isActionInvalid = action.type == ActionType.ProcessContentAssistant
                || (model.id != STATE_ID_END
                    && action.type == ActionType.Redirect);
            if (isActionInvalid) {
                action.$invalid = true;
                model.$invalidCustomActions = true;
                validationErrors.push(new ValidationError('Subflows dont\'t support this action type'));
            }
        };
        if (model.$enteringCustomActions) {
            model.$enteringCustomActions.forEach(validateAction);
        }
        if (model.$leavingCustomActions) {
            model.$leavingCustomActions.forEach(validateAction);
        }
        if (validationErrors.length > 0) {
            throw new ValidationError(`One or more validation errors occurred: ${validationErrors
                .map(e => e.message)
                .join()}`);
        }
    }
}
